import { render, staticRenderFns } from "./AccountAudit.vue?vue&type=template&id=67fef66f&scoped=true&"
import script from "./AccountAudit.vue?vue&type=script&lang=ts&"
export * from "./AccountAudit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fef66f",
  null
  
)

export default component.exports